export default "__VITE_PUBLIC_ASSET__2e1f2d12__"